<template>
  <v-container id="details-container">
    <Title title="Centre Details"></Title>

    <h2 class="py-5" style="display: inline-block;">Centre Details</h2>
    <BulkUploader :type="'centre'" style="float: right;" />

    <v-stepper v-model="e6" vertical>
      <v-stepper-step color="#6490f1" :complete="e6 > 1" step="1" editable>Centre Info</v-stepper-step>
      <v-stepper-content step="1">
        <v-form ref="infoForm">
          <v-row>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="code"
                label="Centre Code (Auto-generated)"
                class="my-3"
                disabled
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                ref="firstInput"
                v-model="name"
                label="Centre Name *"
                :rules="emptyRule"
                class="my-3"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-menu
                ref="firstApprovedDateMenu"
                v-model="firstApprovedDateMenu"
                :close-on-content-click="false"
                :return-value.sync="firstApprovedDate"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="firstApprovedDate"
                    label="First Approved Date"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    class="my-3"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="firstApprovedDate"
                  no-title
                  scrollable
                  @input="$refs.firstApprovedDateMenu.save(firstApprovedDate)"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" md="6">
              <v-menu
                ref="renewalDateMenu"
                v-model="renewalDateMenu"
                :close-on-content-click="false"
                :return-value.sync="renewalDate"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="renewalDate"
                    label="Renewal Date"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    class="my-3"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="renewalDate"
                  no-title
                  scrollable
                  @click="$refs.renewalDateMenu.save(renewalDate)"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field v-model="ukprn" label="UKPRN / Trainer Number" class="my-3"></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-select v-model="status" :items="statuses" label="Status" class="my-3"></v-select>
            </v-col>
            <v-col cols="12" md="12">
              <v-text-field
                v-model="addressLine1"
                label="Address Line 1  *"
                :rules="emptyRule"
                class="my-3"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="12">
              <v-text-field v-model="addressLine2" label="Address Line 2" class="my-3"></v-text-field>
            </v-col>
            <v-col cols="12" md="12">
              <v-text-field v-model="addressLine3" label="Address Line 3" class="my-3"></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field v-model="city" label="City *" class="my-3" :rules="emptyRule"></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field v-model="postcode" label="Post Code" :rules="emptyRule" class="my-3"></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-select
                v-model="country"
                :items="countries"
                label="Country *"
                :rules="emptyRule"
                class="my-3"
              ></v-select>
            </v-col>
          </v-row>
        </v-form>
        <v-btn tile color="#6490f1" dark @click="onProceedSection(2)">Next</v-btn>
        <div class="mb-5"></div>
      </v-stepper-content>

      <v-stepper-step color="#6490f1" :complete="e6 > 2" step="2">Contact Persons</v-stepper-step>
      <v-stepper-content step="2">
        <h4 class="mb-2">Main Contact Person</h4>
        <v-form ref="contactForm">
          <v-row>
            <v-col cols="12" md="4">
              <v-text-field
                v-model="mainContactFirstName"
                label="First Name *"
                class="my-3"
                :rules="emptyRule"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                v-model="mainContactMiddleName"
                label="Middle Name (Optional)"
                class="my-3"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                v-model="mainContactLastName"
                label="Last Name *"
                class="my-3"
                :rules="emptyRule"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                v-model="mainContactEmail"
                label="Email Address *"
                class="my-3"
                :rules="emptyRule"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                v-model="mainContactTelephone"
                label="Telephone *"
                class="my-3"
                :rules="emptyRule"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                v-model="mainContactMobile"
                label="Mobile *"
                class="my-3"
                :rules="emptyRule"
              ></v-text-field>
            </v-col>
          </v-row>

          <h4 class="mb-2">Admin Contact Person</h4>
          <v-row>
            <v-col cols="12" md="4">
              <v-text-field v-model="adminContactFirstName" label="First Name" class="my-3"></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field v-model="adminContactMiddleName" label="Middle Name" class="my-3"></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field v-model="adminContactLastName" label="Last Name" class="my-3"></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field v-model="adminContactEmail" label="Email Address *" class="my-3"></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field v-model="adminContactTelephone" label="Telephone *" class="my-3"></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field v-model="adminContactMobile" label="Mobile *" class="my-3"></v-text-field>
            </v-col>
          </v-row>

          <h4 class="mb-2">Accounts Contact Person</h4>
          <v-row>
            <v-col cols="12" md="4">
              <v-text-field v-model="accountContactFirstName" label="First Name" class="my-3"></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field v-model="accountContactMiddleName" label="Middle Name" class="my-3"></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field v-model="accountContactLastName" label="Last Name" class="my-3"></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field v-model="accountContactEmail" label="Email Address *" class="my-3"></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field v-model="accountContactTelephone" label="Telephone *" class="my-3"></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field v-model="accountContactMobile" label="Mobile *" class="my-3"></v-text-field>
            </v-col>
          </v-row>
        </v-form>
        <v-btn tile color="#6490f1" dark @click="onReviewSummary()">Review Summary</v-btn>
        <div class="mb-5"></div>
      </v-stepper-content>
    </v-stepper>
  </v-container>
</template>

<script>
import BulkUploader from "../components/BulkUploader";
import Title from "../components/Title";

export default {
  mounted: function () {
    this.getCountries();
    this.getStatuses();
    this.getCentre();

    this.$refs.firstInput.focus();
  },
  data() {
    return {
      e6: 1,
      code: null,
      name: null,
      city: null,
      firstApprovedDate: null,
      renewalDate: null,
      ukprn: null,
      status: null,
      addressLine1: null,
      addressLine2: null,
      addressLine3: null,
      postcode: null,
      country: null,
      mainContactFirstName: null,
      mainContactMiddleName: null,
      mainContactLastName: null,
      mainContactEmail: null,
      mainContactTelephone: null,
      mainContactMobile: null,
      adminContactFirstName: null,
      adminContactMiddleName: null,
      adminContactLastName: null,
      adminContactEmail: null,
      adminContactTelephone: null,
      adminContactMobile: null,
      accountContactFirstName: null,
      accountContactMiddleName: null,
      accountContactLastName: null,
      accountContactEmail: null,
      accountContactTelephone: null,
      accountContactMobile: null,
      statuses: [],
      countries: [],
      firstApprovedDateMenu: false,
      renewalDateMenu: false,
      emptyRule: [(v) => !!v || "This field is required"],
    };
  },
  components: {
    BulkUploader,
    Title,
  },
  methods: {
    centreItem: function () {
      return {
        code: this.code,
        name: this.name,
        city: this.city,
        firstApprovedDate: this.firstApprovedDate,
        renewalDate: this.renewalDate,
        ukprn: this.ukprn,
        status: this.status,
        addressLine1: this.addressLine1,
        addressLine2: this.addressLine2,
        addressLine3: this.addressLine3,
        postcode: this.postcode,
        country: this.country,
        mainContactFirstName: this.mainContactFirstName,
        mainContactMiddleName: this.mainContactMiddleName,
        mainContactLastName: this.mainContactLastName,
        mainContactEmail: this.mainContactEmail,
        mainContactTelephone: this.mainContactTelephone,
        mainContactMobile: this.mainContactMobile,
        adminContactFirstName: this.adminContactFirstName,
        adminContactMiddleName: this.adminContactMiddleName,
        adminContactLastName: this.adminContactLastName,
        adminContactEmail: this.adminContactEmail,
        adminContactTelephone: this.adminContactTelephone,
        adminContactMobile: this.adminContactMobile,
        accountContactFirstName: this.accountContactFirstName,
        accountContactMiddleName: this.accountContactMiddleName,
        accountContactLastName: this.accountContactLastName,
        accountContactEmail: this.accountContactEmail,
        accountContactTelephone: this.accountContactTelephone,
        accountContactMobile: this.accountContactMobile,
      };
    },
    getStatuses: function () {
      fetch(`${process.env.VUE_APP_ROOT_API}/centreStatuses`, {
        headers: {
          Authorization: `Bearer ${this.$store.state.jwt}`,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          console.log(data);
          this.statuses = data.centreStatuses.map((status) => status.name);
        })
        .catch((error) => {
          console.error(error);
        });
    },
    getCountries: function () {
      fetch(`${process.env.VUE_APP_ROOT_API}/countries`, {
        headers: {
          Authorization: `Bearer ${this.$store.state.jwt}`,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          this.countries = data.countries.map((country) => country.name);
        })
        .catch((error) => {
          console.error(error);
        });
    },
    writeToForm: function (item) {
      this.code = item.code;
      this.name = item.name;
      this.city = item.city;
      this.firstApprovedDate = item.firstApprovedDate;
      this.renewalDate = item.renewalDate;
      this.ukprn = item.ukprn;
      this.status = item.status;
      this.addressLine1 = item.addressLine1;
      this.addressLine2 = item.addressLine2;
      this.addressLine3 = item.addressLine3;
      this.postcode = item.postcode;
      this.country = item.country;
      this.mainContactFirstName = item.mainContactFirstName;
      this.mainContactMiddleName = item.mainContactMiddleName;
      this.mainContactLastName = item.mainContactLastName;
      this.mainContactEmail = item.mainContactEmail;
      this.mainContactTelephone = item.mainContactTelephone;
      this.mainContactMobile = item.mainContactMobile;
      this.adminContactFirstName = item.adminContactFirstName;
      this.adminContactMiddleName = item.adminContactMiddleName;
      this.adminContactLastName = item.adminContactLastName;
      this.adminContactEmail = item.adminContactEmail;
      this.adminContactTelephone = item.adminContactTelephone;
      this.adminContactMobile = item.adminContactMobile;
      this.accountContactFirstName = item.accountContactFirstName;
      this.accountContactMiddleName = item.accountContactMiddleName;
      this.accountContactLastName = item.accountContactLastName;
      this.accountContactEmail = item.accountContactEmail;
      this.accountContactTelephone = item.accountContactTelephone;
      this.accountContactMobile = item.accountContactMobile;
    },
    getCentre: function () {
      if (this.$route.params.item) {
        // edit new centre
        this.writeToForm(this.$route.params.item);
      } else if (this.$route.query.id) {
        // edit exisiting centre
        fetch(
          `${process.env.VUE_APP_ROOT_API}/centres/${this.$route.query.id}`,
          { headers: { Authorization: `Bearer ${this.$store.state.jwt}` } }
        )
          .then((response) => response.json())
          .then((data) => {
            this.writeToForm(data.centre);
          })
          .catch((error) => {
            console.error(error);
          });
      }
    },
    onProceedSection: function (nextSectionNum) {
      if (this.validateForm(0)) {
        this.e6 = nextSectionNum;
      }
    },
    onReviewSummary: function () {
      if (!this.validateForm(1)) {
        return;
      }

      if (this.$route.query.id) {
        this.$router.push({
          name: "Summary",
          params: { section: "centres", item: this.centreItem() },
          query: { id: this.$route.query.id },
        });
      } else {
        this.$router.push({
          name: "Summary",
          params: { section: "centres", item: this.centreItem() },
        });
      }
    },
    validateForm: function (formIndex) {
      let validate;

      if (formIndex == 0) {
        validate = this.$refs.infoForm.validate();
      } else if (formIndex == 1) {
        validate = this.$refs.contactForm.validate();
      }

      return validate;
    },
  },
};
</script>

<style scoped>
* {
  padding-top: 0;
  padding-bottom: 0;
}

.form-title {
  display: inline-block;
}

#continue-btn {
  float: right;
}

#preview-container {
  height: 500px;
  overflow-y: scroll;
}

#details-container {
  min-height: 100vh;
}

/* md size */
@media (min-width: 960px) {
}

/* sm size */
@media (min-width: 600px) and (max-width: 960px) {
}

/* xs size */
@media only screen and (max-width: 600px) {
}
</style>